import * as TypeGraphQL from "type-graphql";
export var MarketRegime;
(function (MarketRegime) {
    MarketRegime["BULL"] = "BULL";
    MarketRegime["BEAR"] = "BEAR";
    MarketRegime["SIDEWAYS"] = "SIDEWAYS";
    MarketRegime["HIGH_VOLATILITY"] = "HIGH_VOLATILITY";
    MarketRegime["LOW_VOLATILITY"] = "LOW_VOLATILITY";
    MarketRegime["TRENDING"] = "TRENDING";
    MarketRegime["MEAN_REVERTING"] = "MEAN_REVERTING";
})(MarketRegime || (MarketRegime = {}));
TypeGraphQL.registerEnumType(MarketRegime, {
    name: "MarketRegime",
    description: undefined,
});
//# sourceMappingURL=MarketRegime.js.map